"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LabelPopover = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _get = _interopRequireDefault(require("lodash/get"));
var _trim = _interopRequireDefault(require("lodash/trim"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _unionBy = _interopRequireDefault(require("lodash/unionBy"));
var _ControlPoint = _interopRequireDefault(require("@material-ui/icons/ControlPoint"));
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _LabelSelector = _interopRequireWildcard(require("./LabelSelector"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _excluded = ["inline", "trigger", "labels", "onClick", "onChange", "onAddLabel", "validate"],
  _excluded2 = ["isOpen", "anchorEl", "onClose", "onNewLabel", "onChange", "validate", "labels"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = function _default(_ref) {
  var _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? /*#__PURE__*/_react["default"].createElement(DefaultTrigger, null) : _ref$trigger,
    labels = _ref.labels,
    _onClick = _ref.onClick,
    onChange = _ref.onChange,
    onAddLabel = _ref.onAddLabel,
    validate = _ref.validate,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var anchorEl = (0, _react.useRef)(null);
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  function onClose() {
    setOpen(false);
  }
  function onNewLabel(name) {
    setOpen(false);
    onAddLabel((0, _trim["default"])(name));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative', {
      'inline-block': inline
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: anchorEl
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: t('button.labels')
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "w-full",
    onClick: function onClick() {
      setOpen(true);
      _onClick && _onClick();
    }
  }, trigger)), /*#__PURE__*/_react["default"].createElement(LabelPopover, (0, _extends2["default"])({
    anchorEl: anchorEl.current,
    isOpen: isOpen,
    onClose: onClose,
    onNewLabel: onNewLabel,
    onChange: onChange,
    validate: validate,
    labels: labels
  }, rest))));
};
var LabelPopover = exports.LabelPopover = function LabelPopover(_ref2) {
  var isOpen = _ref2.isOpen,
    anchorEl = _ref2.anchorEl,
    onClose = _ref2.onClose,
    onNewLabel = _ref2.onNewLabel,
    onChange = _ref2.onChange,
    validate = _ref2.validate,
    labels = _ref2.labels,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var _useState3 = (0, _react.useState)(labels.filter(function (item) {
      return item.checked;
    })),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    values = _useState4[0],
    setValues = _useState4[1];
  (0, _react.useEffect)(function () {
    setValues(labels.filter(function (item) {
      return item.checked;
    }));
    return function () {
      setValues(labels.filter(function (item) {
        return item.checked;
      }));
    };
  }, [isOpen]);
  var _useMemo = (0, _react.useMemo)(function () {
      var _labels$reduce = labels.reduce(function (_ref3, curr) {
          var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
            checked = _ref4[0],
            unchecked = _ref4[1];
          return curr.checked ? [[].concat((0, _toConsumableArray2["default"])(checked), [curr]), unchecked] : [checked, [].concat((0, _toConsumableArray2["default"])(unchecked), [curr])];
        }, [[], []]),
        _labels$reduce2 = (0, _slicedToArray2["default"])(_labels$reduce, 2),
        checked = _labels$reduce2[0],
        unchecked = _labels$reduce2[1];
      return [checked, unchecked].map(function (item) {
        return item.sort(function (a, b) {
          return a.name < b.name ? -1 : 1;
        });
      });
    }),
    _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 2),
    checked = _useMemo2[0],
    unchecked = _useMemo2[1];
  var isChanged = !(0, _isEqual["default"])(checked.map(function (label) {
    return label.id;
  }).sort(), values.map(function (label) {
    return label.id;
  }).sort());
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], (0, _extends2["default"])({
    open: isOpen,
    anchorEl: anchorEl,
    onClose: onClose,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    elevation: 2
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-64 py-4",
    style: {
      minHeight: 318
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center px-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 text-xl font-bold"
  }, t('navigation.labels')), isChanged && /*#__PURE__*/_react["default"].createElement("button", {
    className: "flex-shrink-0 font-semibold px-2 py-1 hover:bg-secondary text-primary rounded text-sm",
    onClick: function onClick() {
      if (isChanged) {
        onChange(values.filter(function (each) {
          return each.checked;
        }));
      }
      onClose();
    }
  }, t('button.apply'))), /*#__PURE__*/_react["default"].createElement(_LabelSelector["default"], {
    validate: validate,
    labels: [].concat((0, _toConsumableArray2["default"])(checked), (0, _toConsumableArray2["default"])(unchecked)),
    renderField: function renderField(_ref5) {
      var label = _ref5.label,
        index = _ref5.index,
        formikProps = _ref5.formikProps;
      return /*#__PURE__*/_react["default"].createElement(_LabelSelector.LabelField, {
        multi: true,
        index: index,
        onClick: function onClick(label) {
          var res = (0, _unionBy["default"])([label], values, 'id').filter(function (item) {
            return item.checked;
          });
          setValues(res);
        }
      });
    },
    renderButton: function renderButton(_ref6) {
      var name = _ref6.name,
        formikProps = _ref6.formikProps;
      var error = (0, _get["default"])(formikProps, 'errors.name');
      return (0, _isNil["default"])(error) ? /*#__PURE__*/_react["default"].createElement(_LabelSelector.CreateButton, {
        name: name,
        onClick: function onClick() {
          return onNewLabel(name);
        }
      }) : null;
    }
  })));
};
var DefaultTrigger = function DefaultTrigger() {
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "hover:text-primary text-gray-light"
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "inherit",
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_ControlPoint["default"], {
    fontSize: "small"
  })));
};
//# sourceMappingURL=LabelPicker.js.map